'use strict';

var _ = require('lodash');
function HepService($window, $q, restangular, App, $log, serviceClassGroupConfigService) {
  function loadSimpleHepProperties() {
    return restangular.one('configuration').one('hepSimple').get().then(function (data) {
      App.hep = data.properties;
    });
  }
  function getSimpleHepProperties() {
    return App.hep || {};
  }
  function retrieveSimpleHepProperties(hepType) {
    return restangular.one('configuration').one('hepSimple').get({
      'engineCategory': hepType
    }).then(function (data) {
      return data.properties;
    });
  }
  function getSimpleHepProperty(property) {
    var prop = _.get(App, ['hep', property]);
    if (prop !== undefined) {
      return prop;
    }
    return _.get(App, ['hepDA', property]);
  }
  function initUserLevelsForApprovePOS() {
    App.primaryLevelPos = [];
    App.lastLevelPos = [];
    App.isOnlyApproverPos = [];
  }
  function loadClassGroupConfig() {
    return restangular.one('configuration').one('hep').get({
      type: 'ServiceClassGroupConfig'
    }).then(function (data) {
      serviceClassGroupConfigService.processServiceClassGroupConfig(data, 'serviceClassGroupConfigParams');
    });
  }
  function loadFOTariffMatrixConfig() {
    return restangular.one('configuration').one('hep').get({
      type: 'FOTariffMatrixConfig'
    }).then(function (data) {
      processFOTariffMatrix(data);
    });
  }
  function processFOTariffMatrix(data) {
    var tariffList = [];
    _.forEach(data.hepList[0].properties['tariffMatrixConfigProperties'], function (hepEntry) {
      tariffList.push(hepEntry.rulesTariff);
    });
    App.foTariffMatrix = tariffList;
  }
  function loadFcrConfig() {
    return restangular.one('configuration').one('hep').get({
      type: 'FCRConfig'
    }).then(function (data) {
      //todo: should we transform this here? - this is still open question
      App.fcrConfig = data.hepList;
    });
  }
  function loadFOCabinClassConfig() {
    return restangular.one('configuration').one('hep').one('hierarchy').one('all').get({
      type: 'FOCabinClassConfig'
    }).then(function (data) {
      processFOCabinClassConfig(data, 'cabinClassConfigPropertiesList');
    });
  }
  function processFOCabinClassConfig(data, paramsField) {
    var allFOCabinClassesByHepKey = {};
    var allFOCabinClasses = [];
    _.forEach(data.hepList, function (hepEntry) {
      var foCabinClassConfig = hepEntry.properties[paramsField];
      var cabinClassKey = hepEntry.hepKey.split('.').slice(1).join(':');
      allFOCabinClassesByHepKey[cabinClassKey] = getCategoryCabinRbdMappingByHepKey(foCabinClassConfig);
      allFOCabinClasses.push.apply(allFOCabinClasses, foCabinClassConfig);
    });
    App.foCategoryCabinRbds = allFOCabinClassesByHepKey;
    processAllFOCabinClassConfig(allFOCabinClasses);
  }
  function getCategoryCabinRbdMappingByHepKey(foCabinClassConfig) {
    var cabinClassRbdMap = {};
    return _.reduce(foCabinClassConfig, function (cabinClassRbdMap, eachCabinClassConfig) {
      if (_.isNil(cabinClassRbdMap[eachCabinClassConfig.category])) {
        cabinClassRbdMap[eachCabinClassConfig.category] = {};
      }
      if (_.isNil(cabinClassRbdMap[eachCabinClassConfig.category][eachCabinClassConfig.cabin])) {
        cabinClassRbdMap[eachCabinClassConfig.category][eachCabinClassConfig.cabin] = [];
      }
      cabinClassRbdMap[eachCabinClassConfig.category][eachCabinClassConfig.cabin].push(eachCabinClassConfig.className);
      return cabinClassRbdMap;
    }, cabinClassRbdMap);
  }
  function processAllFOCabinClassConfig(foCabinClassConfig) {
    App.foCabins = _.chain(foCabinClassConfig).uniqBy('cabinIndex').sortBy('cabinIndex').map('cabin').uniq().value();
    App.foRbds = _.chain(foCabinClassConfig).sortBy('classIndex').reverse().map('className').uniq().value();
  }
  function processFOAnalystPosMapping(data, paramsField) {
    initUserLevelsForApprovePOS();
    _.forEach(data.hepList, function (hepEntry) {
      var analystMapConfig = hepEntry.properties[paramsField];
      var filteredFOAnalystMapping = _.chain(analystMapConfig).sortBy('level').map(function (items) {
        return _.chain(items.approversList).map('userName').map(splitUserName).flatten().value();
      }).value();
      if (filteredFOAnalystMapping) {
        var lastApprovers = _.last(filteredFOAnalystMapping);
        if (_.indexOf(lastApprovers, App.User.userId) !== -1) {
          App.lastLevelPos.push(hepEntry.attributes.pos);
        }
        filteredFOAnalystMapping = filteredFOAnalystMapping.slice(0, filteredFOAnalystMapping.length - 1);
        filteredFOAnalystMapping = _.flatten(filteredFOAnalystMapping);
        if (_.size(filteredFOAnalystMapping) === 0) {
          App.isOnlyApproverPos.push(hepEntry.attributes.pos);
        }
        if (_.indexOf(filteredFOAnalystMapping, App.User.userId) !== -1) {
          App.primaryLevelPos.push(hepEntry.attributes.pos);
        }
      }
    });
  }
  function splitUserName(userName) {
    return userName.split(',');
  }
  function loadFoAnalystPosMapping() {
    return restangular.one('configuration').one('hep').get({
      type: 'FOAnalystPosMapping'
    }).then(function (data) {
      processFOAnalystPosMapping(data, 'foAnalystPosMappingProperties');
    });
  }
  function loadSystemProperties() {
    return restangular.one('configuration').one('hep').get({
      type: 'SystemProperties'
    }).then(function (data) {
      processSystemProperties(data);
    });
  }
  function loadDefaultQueryConfigurations() {
    return restangular.one('configuration').one('hep').one('defaults').get({
      type: 'QueryConfig'
    }).then(processDefaultQueryConfiguration);
  }
  function processDefaultQueryConfiguration(data) {
    var systemLevelProperties = _.get(data, ['hepList', 0, 'properties'], {});
    App.maxLimit = systemLevelProperties.maxLimit || 100000;
    App.softLimit = systemLevelProperties.softLimit;
    App.pageLimit = systemLevelProperties.pageLimit;
    App.threadsQuantity = systemLevelProperties.threadsQuantity;
  }
  function loadQueryConfigurations() {
    return restangular.one('configuration').one('hep').get({
      type: 'QueryConfig'
    }).then(processQueryConfigurations);
  }
  function processQueryConfigurations(data) {
    App.dataRetrievalConfigs = _.get(data, 'hepList', []);
  }
  function processSystemProperties(data) {
    App.systemProperties = _.find(data.hepList, {
      hepKey: 'SystemProperties'
    }).properties;
  }

  /**
   * Update Sponsors data
   * @param {Array} hep
   */
  function addHep(hep) {
    return restangular.one('configuration').one('hep').one('bulk').customPUT({
      value: hep
    }, undefined, {
      upsert: true
    });
  }

  /**
   * Update special events
   * @param {Array} payload
   */
  function addEvents(payload) {
    return restangular.one('configuration').one('hep').one('specialEvent').one('bulk').customPUT({
      value: payload
    });
  }
  function getHepByType(type) {
    return restangular.one('configuration').one('hep').get({
      type: type
    });
  }

  /**
   * Update Host Share data
   * @param {Array} hostshare
   */
  function updateHostShare(hostshare) {
    return restangular.one('configuration').one('hep').one('hostshare').customPUT(hostshare);
  }

  /**
   * Fetch Host Share data
   */
  function getHostShare() {
    return restangular.one('configuration').one('hep').all('hostshare').get('?pageLimit=-1');
  }
  function loadHostShare() {
    return getHostShare().then(function (data) {
      App.hostShare = data.flattenedHostShares;
    });
  }
  function acceptNPS(payload) {
    return restangular.one('configuration').one('hep').one('hostshare').one('accept_nps').customPUT(payload);
  }
  function fetchNPS() {
    return restangular.one('configuration').one('hep').one('hostshare').one('mock_nps').get();
  }
  function rejectNPS(payload) {
    return restangular.one('configuration').one('hep').one('hostshare').one('reject_nps').customPUT(payload);
  }

  /**
   * Retrieve all market init demand profiles defined in hep for a defined market and SPOS.
   * @param {object} market
   * @param {String} spos
   * @param {String} type
   */
  function getMarketInitDemandProfiles(market, spos, type) {
    var queryParams = {
      type: type,
      filter: ['origin==' + market.origin, 'destination==' + market.destination, 'significantPOS==' + spos, 'scenarioName==PUBLISHED'].join(';')
    };
    return restangular.one('configuration').one('hep').one('all').get(queryParams);
  }

  /**
   * Retrieve competitor time window settings per origin and destination
   * @param origin
   * @param destination
   */
  function getCompetitorTimeWindow(origin, destination) {
    var queryParams = {
      type: 'CompetitorTimeWindow',
      filter: ['origin==' + origin, 'destination==' + destination].join(';')
    };
    return restangular.one('configuration').one('hep').one('all').withHttpConfig({
      cache: true
    }).get(queryParams);
  }
  function getDefaultCompetitorTimeWindow() {
    return restangular.one('configuration').one('hep').one('defaults').withHttpConfig({
      cache: true
    }).get({
      type: 'CompetitorTimeWindow'
    });
  }

  /**
   * Retrieve all show up init profiles defined in hep for a defined leg (origin, destination) and optional businessId.
   * @param {string} origin
   * @param {string} destination
   * @param {string} businessId
   */
  function getShowUpInitProfiles(origin, destination, businessId) {
    var filterItems = ['legOrigin==' + origin, 'legDestination==' + destination, 'scenarioName==PUBLISHED'];
    if (businessId) {
      filterItems.push('legBusinessId==' + origin + '-' + destination + '#' + businessId);
    }
    var queryParams = {
      type: 'ShowUpInitProfile',
      filter: filterItems.join(';')
    };
    return restangular.one('configuration').one('hep').one('all').get(queryParams);
  }
  function getFPMarketConfigParams(origin, destination) {
    var hostCarrier = $window.sessionStorage.getItem('carrierCode');
    var filterItems = ['carrier==' + hostCarrier, 'marketOrigin==' + origin, 'marketDestination==' + destination];
    var queryParams = {
      type: 'FP_MarketConfig',
      filter: filterItems.join(';')
    };
    return restangular.one('configuration').one('hep').one('all').get(queryParams);
  }
  function loadSpecialEvents() {
    return restangular.one('configuration').one('hep').one('specialEvent').get({
      pageLimit: 100000
    }).then(function (data) {
      App.events = data._embedded.simpleFlattenedSpecialEventList;
    });
  }
  function loadSponsors(market, spos) {
    return $q.all([getMarketInitDemandProfiles(market, spos, 'MappedMarketInitDemandProfile'), getMarketInitDemandProfiles(market, spos, 'RegularMarketInitDemandProfile')]).then(function (data) {
      return _.chain(data).filter('hepList').map('hepList').flatten().value();
    });
  }
  function isSystemLevelHepEntry(hepListElement) {
    return _.isUndefined(hepListElement.attributes) || _.isEmpty(hepListElement.attributes);
  }
  function loadDefaultDaysOffsets() {
    return restangular.one('configuration').one('hep').get({
      type: 'BookingsIntakeDaysOffsets'
    }).then(function (data) {
      _.forEach(data.hepList, function (hepEntry) {
        if (isSystemLevelHepEntry(hepEntry)) {
          App.defaultDaysOffsets = hepEntry.properties.daysOffsets;
        }
      });
    });
  }
  function loadROMColorConfiguration() {
    return restangular.one('configuration').one('hep').get({
      type: 'ROMColorConfiguration'
    }).then(function (data) {
      App.ROMColorConfiguration = _.get(data, ['hepList', 0, 'properties']);
    });
  }
  function loadFeatureSpecificSimpleHeps() {
    if (_.some(App.features, {
      feature: 'DYNAMIC_AVAILABILITY',
      enable: true
    })) {
      retrieveSimpleHepProperties('DynamicAvailability').then(function (properties) {
        App.hepDA = properties;
      });
    }
  }
  function loadFeatures() {
    return restangular.one('configuration').one('hep').get({
      type: 'Features'
    }).then(function (data) {
      App.features = _.get(data, ['hepList', 0, 'properties', 'features']);
      loadFeatureSpecificSimpleHeps();
    });
  }
  function loadAdvancePurchasingDepartureDateRange() {
    return restangular.one('configuration').one('hep').get({
      type: 'FP_AP_Range'
    }).then(function (data) {
      var advancePurchasingDepartureDateRanges = _.get(data, ['hepList', 0, 'properties', 'departureDatesRange'], []);
      App.advancePurchasingDepartureDateRanges = _.map(advancePurchasingDepartureDateRanges, 'range');
    });
  }
  function getBenchmarkCarriers(origin, destination, cabinCode) {
    var hostCarrier = $window.sessionStorage.getItem('carrierCode');
    var filterItems = ['marketOrigin==' + origin, 'marketDestination==' + destination, 'cabinCode==' + cabinCode, 'carrier==' + hostCarrier];
    return restangular.one('configuration').one('hep').get({
      type: 'FP_BenchmarkCarriers',
      filter: filterItems.join(';')
    });
  }
  function getAdvancePurchasingDepartureDateRange() {
    return _.cloneDeep(App.advancePurchasingDepartureDateRanges || []);
  }
  function loadFpNesting() {
    var hostCarrier = $window.sessionStorage.getItem('carrierCode');
    var filterItems = 'carrier==' + hostCarrier;
    return restangular.one('configuration').one('hep').get({
      type: 'FP_Nesting',
      filter: filterItems
    }).then(function (nesting) {
      serviceClassGroupConfigService.processServiceClassGroupConfig(nesting, 'nestingParams');
    });
  }
  function loadAllBenchmarkCarriers() {
    return restangular.one('configuration').one('hep').get({
      type: 'FP_BenchmarkCarriers'
    }).then(function (hepResponse) {
      var heps = _.get(hepResponse, ['hepList'], []);
      App.benchmarkCarriers = _.chain(heps).transform(function (result, hep) {
        var carrierList = _.get(hep, ['properties', 'benchmarkCarriers'], []);
        if (!_.isEmpty(carrierList)) {
          result.push(carrierList.split(','));
        }
      }).flatten().uniq().value();
    });
  }
  function loadFoMarkets() {
    App.poses = App.poses || [];
    App.markets = App.markets || [];
    return restangular.one('configuration').one('hep').get({
      type: 'FOMarketList'
    }).then(function (FOMarketListHep) {
      var foMarkets = _.get(FOMarketListHep, ['hepList', 0, 'properties', 'foMarkets']);
      App.markets = processFoMarkets(foMarkets);
      App.poses = processFoPoses(foMarkets);
      App.marketTiers = processFoMarketTiers(foMarkets);
      App.foBenchmarkCarriers = processFoBenchmarkCarriers(foMarkets);
      App.foBenchmarkCarrierToMarketMap = populateBenchmarkCarrierToMarketMap();
    });
  }
  function processFoBenchmarkCarriers(foMarkets) {
    return _.chain(foMarkets).map(function (item) {
      return {
        origin: item.origin,
        destination: item.destination,
        cabin: item.cabinCode,
        category: item.category,
        benchmarkCarriers: item.benchmarkCarrier
      };
    }).value();
  }
  function populateBenchmarkCarrierToMarketMap() {
    var carrierToMarketMap = {};
    _.forEach(App.foBenchmarkCarriers, function (foMarket) {
      _.forEach(foMarket.benchmarkCarriers, function (airline) {
        if (!carrierToMarketMap[airline]) {
          carrierToMarketMap[airline] = [];
        }
        var market = foMarket.origin + '-' + foMarket.destination;
        if (!_.includes(carrierToMarketMap[airline], market)) {
          carrierToMarketMap[airline].push(market);
        }
      });
    });
    return carrierToMarketMap;
  }
  function processFoMarkets(foMarkets) {
    var uniqueFoMarkets = _.chain(foMarkets).map(function (item) {
      return _.pick(item, ['origin', 'destination']);
    }).uniqBy(function (item) {
      return item.origin + item.destination;
    }).value();
    var uniqueFoMarketsCache = _.cloneDeep(uniqueFoMarkets);
    var foMarketsToBeDeleted = [];
    _.forEach(App.markets, function (appMarket) {
      var foMarket = _.find(uniqueFoMarkets, {
        origin: appMarket.origin,
        destination: appMarket.destination
      });
      if (!_.isNil(foMarket)) {
        _.merge(appMarket, foMarket);
        _.remove(uniqueFoMarkets, foMarket);
      }
      if (_.isNil(foMarket) && !_.isNil(_.find(App.foMarkets, {
        origin: appMarket.origin,
        destination: appMarket.destination
      }))) {
        foMarketsToBeDeleted.push(appMarket);
      }
    });
    _.forEach(foMarketsToBeDeleted, function (appMarket) {
      var foMarket = _.find(App.markets, {
        origin: appMarket.origin,
        destination: appMarket.destination
      });
      var marketsCopy = App.markets.slice();
      _.remove(marketsCopy, foMarket);
      App.markets = marketsCopy;
    });
    App.foMarkets = uniqueFoMarketsCache;
    return _.chain(App.markets).concat(uniqueFoMarkets).uniqBy(function (item) {
      return item.origin + item.destination;
    }).value();
  }
  function processFoPoses(foMarkets) {
    var uniqueFoPoses = _.chain(foMarkets).map(function (item) {
      return {
        origin: item.origin,
        destination: item.destination,
        spos: item.pos
      };
    }).value();
    _.forEach(App.poses, function (appPos) {
      var foPos = _.find(uniqueFoPoses, {
        origin: appPos.origin,
        destination: appPos.destination,
        spos: appPos.spos
      });
      if (!_.isNil(foPos)) {
        _.merge(appPos, foPos);
        _.remove(uniqueFoPoses, foPos);
      }
    });
    return _.chain(App.poses).concat(uniqueFoPoses).uniqBy(function (item) {
      return item.origin + item.destination + item.spos;
    }).value();
  }
  function processFoMarketTiers(foMarkets) {
    return _.chain(foMarkets).map(function (item) {
      return {
        marketTier: item.marketTier
      };
    }).value();
  }
  function processFOGroups(hepList, propKey, nestedPropKey, startKey, endKey) {
    return _.chain(hepList).map('properties').map(propKey).map(nestedPropKey).flatten().sortBy(startKey).uniqBy(function (item) {
      return item[startKey] + '.' + item[endKey];
    }).value();
  }
  function getConstraintGroupings(hepList, propKey) {
    return _.reduce(hepList, function (map, hep) {
      map[hep.hepKey] = _.get(hep, ['properties', propKey]);
      return map;
    }, {});
  }
  function loadFOGroups(hepType, propKey, nestedPropKey, startKey, endKey) {
    return restangular.one('configuration').one('hep').get({
      type: hepType
    }).then(function (hepResponse) {
      App[hepType] = processFOGroups(hepResponse.hepList, propKey, nestedPropKey, startKey, endKey);
      var key = hepType + '.' + 'grouping';
      App[key] = getConstraintGroupings(hepResponse.hepList, propKey);
    });
  }
  function loadFoMaxStayGroups() {
    return loadFOGroups('FOMaxStayGrouping', 'foMaxStayGroupingProperties', null, 'maxStayStart', 'maxStayEnd');
  }
  function loadFoMinStayGroups() {
    return loadFOGroups('FOMinStayGrouping', 'foMinStayGroupingProperties', null, 'minStayStart', 'minStayEnd');
  }
  function loadFoAdvPurchaseGroups() {
    return loadFOGroups('FOAdvancePurchaseGrouping', 'advancePurchaseGroupingProperty', 'advancePurchaseGroupingProperties', 'advancePurchaseStart', 'advancePurchaseEnd');
  }
  function loadFoSeasonDefinitions() {
    return restangular.one('configuration').one('hep').get({
      type: 'FOSeasonDefinitions'
    }).then(function (data) {
      App.seasonDefinitions = _.get(data, ['hepList', 0, 'properties', 'seasonDefinitionList']);
    });
  }
  function getHepSimpleByType(type) {
    return restangular.one('configuration').one('hepSimple').get({
      engineCategory: type
    });
  }
  function loadFoSimpleHepProperties() {
    return getHepSimpleByType('FaresOptimizer').then(function (data) {
      App.foSimpleHep = data.properties;
    });
  }
  function loadCurtainRuleIds() {
    return restangular.one('configuration').one('hep').get({
      type: 'CurtainRule'
    }).then(function (data) {
      App.curtainRuleIds = processCurtainRuleIds(data.hepList, 'curtainRuleId');
    });
  }
  function processCurtainRuleIds(hepList, propKey) {
    return _.chain(hepList).map('attributes').map(propKey).flatten().value();
  }
  function loadFlightCategories() {
    return restangular.one('configuration').one('hep').get({
      type: 'FlightCategory'
    }).then(function (data) {
      App.flightCategories = processFlightCagtegories(data.hepList, 'flightCategory');
    });
  }
  function processFlightCagtegories(hepList, propKey) {
    return _.chain(hepList).map('properties.flightCategoryParam').map(propKey).flatten().value();
  }
  function loadFoStatusRejectionCode() {
    return restangular.one('configuration').one('hep').get({
      type: 'FOStatusRejectionCode'
    }).then(function (data) {
      var rejectionCodes = _.get(data, ['hepList', 0, 'properties', 'foStatusRejectionCodePropertiesList']);
      App.foRejectionReasons = _.chain(rejectionCodes).filter(function (r) {
        return r.statusType === 'Rejection';
      }).map(function (item) {
        return item.shortDescription;
      }).value();
    });
  }
  function loadFoRecommendationLadderStatuses() {
    return restangular.one('configuration').one('hep').get({
      type: 'FORecommendationLadderStatus'
    }).then(function (data) {
      var statuses = _.get(data, ['hepList', 0, 'properties', 'foRecommendationLadderStatusList']);
      App.foRecommendationLadderStatuses = _.chain(statuses).map(function (item) {
        return item.status;
      }).value();
    });
  }
  function loadFrequencyConfig() {
    return restangular.one('configuration').one('hep').get({
      type: 'Frequency'
    }).then(function (data) {
      App.interfaceStatusFrequency = _.get(data, 'hepList.0.properties.frequency', {});
    });
  }
  function loadFoSmoothingMethods() {
    return restangular.one('configuration').one('hep').get({
      type: 'FOSmoothingMethods'
    }).then(function (data) {
      App.foSmoothingMethods = _.get(data, ['hepList', 0, 'properties', 'foSmoothingMethodsList']);
    });
  }
  function processFoAirportRegionMapping(airportRegionMapping) {
    var airportCodes = {};
    var cityCodes = {};
    var countries = {};
    var regions = {};
    var poses = {};
    _.each(airportRegionMapping, function (item) {
      airportCodes[item.airportCode] = true;
      cityCodes[item.cityCode] = true;
      countries[item.country] = true;
      regions[item.region] = true;
      poses[item.pos] = true;
    });
    App.foAirportRegionMapping = airportRegionMapping;
    App.foAirportCodes = _.keys(airportCodes).sort();
    App.foCityCodes = _.keys(cityCodes).sort();
    App.foCountries = _.keys(countries).sort();
    App.foRegions = _.keys(regions).sort();
    App.foPoses = _.keys(poses).filter(function (pos) {
      return !_.isNil(pos) && !_.isEmpty(pos);
    }).sort();
  }
  function loadFoAirportRegionMapping() {
    return restangular.one('configuration').one('hep').get({
      type: 'FOAirportRegionMapping'
    }).then(function (data) {
      var airportRegionMapping = _.get(data, ['hepList', 0, 'properties', 'airportRegionMappings']);
      processFoAirportRegionMapping(airportRegionMapping);
    });
  }
  function loadDefaultWorkflowSettings() {
    return restangular.one('configuration').one('hep').get({
      type: 'WorkflowSettings'
    }).then(function (hepData) {
      App.defaultWorkflowSettings = _.get(hepData, ['hepList', 0, 'properties', 'workflowSettings'], {});
    });
  }
  function loadSystemStatusConfig() {
    return restangular.one('configuration').one('hep').get({
      type: 'SystemStatusConfig'
    }).then(function (hepData) {
      var systemStatusConfig = _.get(hepData, ['hepList', 0, 'properties', 'systemStatusParams'], {});
      App.systemStatusConfigMap = _.chain(systemStatusConfig).keyBy('app').mapValues('fileType').value();
    });
  }
  function loadFoCurrencies() {
    return restangular.one('configuration').one('hep').get({
      type: 'FOCurrencyConversion'
    }).then(function (FOCurrencyConversionHep) {
      var foCurrencies = _.get(FOCurrencyConversionHep, ['hepList', 0, 'properties', 'foCurrencyConversionPropertiesSet']);
      processFoCurrencies(foCurrencies);
    });
  }
  function processFoCurrencies(foCurrencies) {
    var foCurrenciesArray = {};
    _.each(foCurrencies, function (item) {
      foCurrenciesArray[item.currencyCode] = true;
    });
    App.foCurrencies = _.keys(foCurrenciesArray).sort();
  }
  function loadFoRecommendationReasons() {
    return restangular.one('configuration').one('hep').get({
      type: 'FORecommendationReasons'
    }).then(function (FORecommendationReasonsHep) {
      var foRecommendationReasonList = _.get(FORecommendationReasonsHep, ['hepList', 0, 'properties', 'foRecommendationReasonList']);
      processFoRecommendationReasons(foRecommendationReasonList);
    });
  }
  function processFoRecommendationReasons(foRecommendationReasonList) {
    App.foShortRecommendationReasons = _.chain(foRecommendationReasonList).mapValues('shortDescription').value();
    App.foShortRecommendationReasons = _.values(App.foShortRecommendationReasons).sort();
  }
  function loadFoFareBrandDefinitions() {
    return restangular.one('configuration').one('hep').get({
      type: 'FOFareBrandDefinitionConfig'
    }).then(function (fareBrandDefinitionConfig) {
      App.fareBrandDefinitionProperties = _.get(fareBrandDefinitionConfig, ['hepList', 0, 'properties', 'fareBrandDefinitionProperties']);
    });
  }
  function loadDAFareBrandDefinitions() {
    return restangular.one('configuration').one('hep').get({
      type: 'DA_FareBrandDefinition'
    }).then(function (fareBrandDefinitionConfig) {
      App.daFareBrandDefinition = aggregateFareBrandHepByCarrier(fareBrandDefinitionConfig, 'fareBrandDefinitionParams', 'fareBrandConfiguration');
    })["catch"](function () {
      App.daFareBrandDefinition = {};
    });
  }
  function loadDAFareBrandNormalizations() {
    return restangular.one('configuration').one('hep').get({
      type: 'DA_FareBrandNormalization'
    }).then(function (fareBrandNormalizationConfig) {
      App.daFareBrandNormalization = aggregateFareBrandHepByCarrier(fareBrandNormalizationConfig, 'fareBrandNormalizationParams', 'daFareBrand');
    })["catch"](function () {
      App.daFareBrandNormalization = {};
    });
  }
  function loadDAFareBrandAssignments() {
    return restangular.one('configuration').one('hep').get({
      type: 'DA_FareBrandAssignment'
    }).then(function (fareBrandAssignmentConfig) {
      App.daFareBrandAssignment = aggregateFareBrandHepByCarrier(fareBrandAssignmentConfig, 'fareBrandAssignmentParams', 'fareBrandConfiguration');
    })["catch"](function () {
      App.daFareBrandAssignment = {};
    });
  }
  function aggregateFareBrandHepByCarrier(fareBrandConfig, fareBrandParams, fareBrandPropertyName) {
    var hepForCarriers = {};
    _.forEach(fareBrandConfig.hepList, function (fareBrandHepEntity) {
      var carrier = _.get(fareBrandHepEntity, ['attributes', 'carrier']);
      var fareBrands = _.chain(_.get(fareBrandHepEntity, ['properties', fareBrandParams])).map(fareBrandPropertyName).uniq().value();
      if (!hepForCarriers[carrier]) {
        hepForCarriers[carrier] = fareBrands;
      } else {
        hepForCarriers[carrier] = _.uniq(hepForCarriers[carrier].concat(fareBrands));
      }
    });
    return hepForCarriers;
  }
  return {
    loadSimpleHepProperties: loadSimpleHepProperties,
    getSimpleHepProperties: getSimpleHepProperties,
    retrieveSimpleHepProperties: retrieveSimpleHepProperties,
    getSimpleHepProperty: getSimpleHepProperty,
    loadClassGroupConfig: loadClassGroupConfig,
    loadFcrConfig: loadFcrConfig,
    addHep: addHep,
    addEvents: addEvents,
    updateHostShare: updateHostShare,
    loadHostShare: loadHostShare,
    acceptNPS: acceptNPS,
    rejectNPS: rejectNPS,
    fetchNPS: fetchNPS,
    getHepByType: getHepByType,
    getMarketInitDemandProfiles: getMarketInitDemandProfiles,
    getFPMarketConfigParams: getFPMarketConfigParams,
    getShowUpInitProfiles: getShowUpInitProfiles,
    getCompetitorTimeWindow: getCompetitorTimeWindow,
    getDefaultCompetitorTimeWindow: getDefaultCompetitorTimeWindow,
    loadSpecialEvents: loadSpecialEvents,
    loadSponsors: loadSponsors,
    loadROMColorConfiguration: loadROMColorConfiguration,
    loadFeatures: loadFeatures,
    loadDefaultQueryConfigurations: loadDefaultQueryConfigurations,
    loadQueryConfigurations: loadQueryConfigurations,
    loadSystemProperties: loadSystemProperties,
    loadAdvancePurchasingDepartureDateRange: loadAdvancePurchasingDepartureDateRange,
    getBenchmarkCarriers: getBenchmarkCarriers,
    loadAllBenchmarkCarriers: loadAllBenchmarkCarriers,
    getAdvancePurchasingDepartureDateRange: getAdvancePurchasingDepartureDateRange,
    loadFpNesting: loadFpNesting,
    loadFoMarkets: loadFoMarkets,
    loadFoMaxStayGroups: loadFoMaxStayGroups,
    loadFoMinStayGroups: loadFoMinStayGroups,
    loadFoAdvPurchaseGroups: loadFoAdvPurchaseGroups,
    loadFoSeasonDefinitions: loadFoSeasonDefinitions,
    loadFoSimpleHepProperties: loadFoSimpleHepProperties,
    loadCurtainRuleIds: loadCurtainRuleIds,
    loadFlightCategories: loadFlightCategories,
    loadDefaultDaysOffsets: loadDefaultDaysOffsets,
    loadFoStatusRejectionCode: loadFoStatusRejectionCode,
    loadFoAnalystPosMapping: loadFoAnalystPosMapping,
    loadFoRecommendationLadderStatuses: loadFoRecommendationLadderStatuses,
    loadFrequencyConfig: loadFrequencyConfig,
    loadFoSmoothingMethods: loadFoSmoothingMethods,
    loadDefaultWorkflowSettings: loadDefaultWorkflowSettings,
    loadFOCabinClassConfig: loadFOCabinClassConfig,
    loadFoAirportRegionMapping: loadFoAirportRegionMapping,
    loadSystemStatusConfig: loadSystemStatusConfig,
    loadFoCurrencies: loadFoCurrencies,
    loadFoRecommendationReasons: loadFoRecommendationReasons,
    loadFoFareBrandDefinitions: loadFoFareBrandDefinitions,
    loadDAFareBrandDefinitions: loadDAFareBrandDefinitions,
    loadDAFareBrandNormalizations: loadDAFareBrandNormalizations,
    loadFeatureSpecificSimpleHeps: loadFeatureSpecificSimpleHeps,
    loadDAFareBrandAssignments: loadDAFareBrandAssignments,
    loadFOTariffMatrixConfig: loadFOTariffMatrixConfig
  };
}
HepService.$inject = ['$window', '$q', 'Restangular', 'App', '$log', 'ServiceClassGroupConfigService'];
module.exports = HepService;